import Vue from 'vue'
import tplBase from './tplBase'
import tplDivider from './tplDivider'
import tplList from './tplList'
import tplRecord from './tplRecord'
import tplRecordView from './tplRecordView'
import tplSearch from './tplSearch'

Vue.component('tpl-base', tplBase)
Vue.component('tpl-divider', tplDivider)
Vue.component('tpl-list', tplList)
Vue.component('tpl-record', tplRecord)
Vue.component('tpl-record-view', tplRecordView)
Vue.component('tpl-search', tplSearch)
